import { useRef } from "react";
import { films } from "@/mocks/films";
import PosterCard from "@/pages/home/components/PosterCard";

export default function NewReleases() {
  const railRef = useRef<HTMLDivElement>(null);
  const newFilms = films.filter((f) => f.isNew);

  const scrollBy = (dir: number) => {
    const rail = railRef.current;
    if (!rail) return;
    rail.scrollBy({ left: dir * (rail.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section id="new-releases" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="inline-flex items-center gap-2 font-label text-[11px] tracking-[0.3em] uppercase text-primary-500">
              <span className="w-6 h-px bg-primary-500" />
              The Voltage Slate
            </span>
            <h2 className="mt-3 font-heading font-extrabold uppercase tracking-tight text-foreground-950 text-3xl md:text-5xl">
              New Releases
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
              Fresh theatrical and on-demand titles from our current slate, ready for
              worldwide licensing.
            </p>
          </div>

          <div className="flex items-center gap-3">
            <button
              type="button"
              aria-label="Scroll left"
              onClick={() => scrollBy(-1)}
              className="hidden md:flex items-center justify-center w-11 h-11 rounded-full border border-background-300 text-foreground-800 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button
              type="button"
              aria-label="Scroll right"
              onClick={() => scrollBy(1)}
              className="hidden md:flex items-center justify-center w-11 h-11 rounded-full border border-background-300 text-foreground-800 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
            <a
              href="#library"
              className="inline-flex items-center gap-2 rounded-md border border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50 font-label text-xs tracking-[0.18em] uppercase px-5 py-3.5 whitespace-nowrap transition-colors cursor-pointer"
            >
              View Library
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div
          ref={railRef}
          className="no-scrollbar mt-10 flex gap-5 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-1"
        >
          {newFilms.map((film) => (
            <div
              key={film.id}
              className="snap-start shrink-0 w-[68%] sm:w-[40%] lg:w-[23%] xl:w-[19%]"
            >
              <PosterCard film={film} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}